(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AsyncApiWebComponent", [], factory);
	else if(typeof exports === 'object')
		exports["AsyncApiWebComponent"] = factory();
	else
		root["AsyncApiWebComponent"] = factory();
})(window, function() {
return 